import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import HomeworkRow from "./HomeworkRow";
import { webUrlNode } from "../../../constants/appInfo";
import { useParams } from "react-router-dom";
import HomeworkPopUp from "./HomeworkPopUp";
import FolderFilterCard from "../CreateContent/FolderFilterCard";
import HomeworkRowDisplay from "./HomeworkRowDisplay";

export default function HomeworkPanel({ onClose }) {

  const { batchId } = useParams();

  const [items, setItems] = useState([]);
  const [linkedMap, setLinkedMap] = useState({});
  const [loading, setLoading] = useState(false);
  const [showHomeworks, setShowHomeworks] = useState(false);
  

  const AppToken = useSelector((s)=>s?.app?.app?.AppToken);
  const coursePostId = useSelector((s)=>s?.course?.course?.postId);
  const currentToken = useSelector((s)=>s?.user?.user?.token);

  useEffect(()=>{
    if(!coursePostId || !batchId) return;
    loadData();
  },[coursePostId,batchId,showHomeworks]);


  async function loadData(){

    setLoading(true);

    try{

      // fetch all homeworks
      const hwRes = await axios.get(
        `${webUrlNode}/api/homework`,
        {
          params:{
            appToken:AppToken,
            coursePostId,
            currentToken
          }
        }
      );

      const homework = hwRes.data.items || [];
      setItems(homework);


      // fetch linked homework
      const linkRes = await axios.get(
        `${webUrlNode}/api/batches/${batchId}/homework`,
        {
          params:{appToken:AppToken}
        }
      );

      const linked = linkRes.data.items || [];

      const map = {};

      linked.forEach((row)=>{
        map[row.homeworkId] = {
          id:row.id,
          releaseAt: row.releaseAt ? row.releaseAt.split("T")[0] : "",
          dueAt: row.dueAt ? row.dueAt.split("T")[0] : ""
        };
      });

      setLinkedMap(map);

    }
    catch(e){
      console.error(e);
    }

    setLoading(false);

  }

  const linkedHomeworks = items.filter(hw => linkedMap[hw.id]);

  return(

    <div>
{showHomeworks?<HomeworkPopUp onClose={()=>{setShowHomeworks(false)}} /> :""}
      <div>

        <div className="modalHeader">
          <h3>Linked Homework</h3> 
          
<FolderFilterCard activeCard={true}   icon={6} title ="+ Homework" onClickPopup={()=>{
   setShowHomeworks(true) ;
} }  /> 
        
        </div>

        {loading && <div>Loading...</div>}

        {!loading && linkedHomeworks.length === 0 && (
          <div style={{padding:20,color:"#777"}}>
            No homework linked to this batch yet
          </div>
        )}

        {!loading && linkedHomeworks.map((hw,i)=>{

          const checked = true;

          return(
            <HomeworkRowDisplay
              key={hw.id}
              homework={hw}
              index={i}
              batchId={batchId}
              checked={checked}
              linkedMap={linkedMap}
              setLinkedMap={setLinkedMap}
              setShowHomeworks={()=>{setShowHomeworks(true)}}
            />
          )

        })}

      </div>

<style>{`

.closeBtn{
border:none;
background:#f5f5f5;
width:32px;
height:32px;
border-radius:6px;
cursor:pointer;
}

.closeBtn:hover{
background:#eaeaea;
}

.modalHeader{
display:flex;
justify-content:space-between;
margin-bottom:10px;
}

`}</style>

    </div>

  );

}